<script setup>
const { favouriteUnits, addtoFavourite, removeFromFavourite, fetchFavouriteUnits } = useAuthUser()

onBeforeMount(async () => {
    const { $auth } = useNuxtApp()

    if ($auth.authenticated) {
        await fetchFavouriteUnits()
    }
})
</script>

<template>
    <ClientOnly>
        <v-row>
            <div
                v-if="favouriteUnits"
                @click="$router.push('/compare')"
                class="cursor-pointer d-inline-block"
            >
                <v-chip><v-icon>mdi-star</v-icon></v-chip>
                <v-chip v-for="unit in favouriteUnits" :key="unit.unitId" class="ma-2">
                    <v-tooltip :text="`${unit.building.project.name} > ${unit.building.name}`">
                        <template v-slot:activator="{ props }">
                            <span v-bind="props"> {{ unit.title }}</span>
                        </template>
                    </v-tooltip>
                </v-chip>
            </div>
        </v-row>
    </ClientOnly>
</template>
